import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, Alert } from 'react-bootstrap';
import AddressFields from './AddressFields';

const AddressModal = ({ 
  show, 
  onHide, 
  onSave, 
  address = null, 
  loading = false 
}) => {
  const [formData, setFormData] = useState({
    first_name: address?.first_name || '',
    last_name: address?.last_name || '',
    company: address?.company || '',
    address_line_1: address?.address_line_1 || '',
    address_line_2: address?.address_line_2 || '',
    city: address?.city || '',
    state: address?.state || '',
    zip_code: address?.zip_code || '',
    country: address?.country || 'US',
    is_default: address?.is_default || false
  });
  
  const [error, setError] = useState('');

  // Update form data when address prop changes
  useEffect(() => {
    if (show) {
      setFormData({
        first_name: address?.first_name || '',
        last_name: address?.last_name || '',
        company: address?.company || '',
        address_line_1: address?.address_line_1 || '',
        address_line_2: address?.address_line_2 || '',
        city: address?.city || '',
        state: address?.state || '',
        zip_code: address?.zip_code || '',
        country: address?.country || 'US',
        is_default: address?.is_default || false
      });
      setError('');
    }
  }, [address, show]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const setAddressData = (addressData) => {
    setFormData(prev => ({
      ...prev,
      ...addressData
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validate required fields
    if (!formData.first_name || !formData.last_name || !formData.address_line_1 || 
        !formData.city || !formData.state || !formData.zip_code) {
      setError('Please fill in all required fields');
      return;
    }

    // Ensure country is always "US" for backend
    const submissionData = {
      ...formData,
      country: 'US'
    };
    onSave(submissionData);
  };

  const handleClose = () => {
    setError('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {address ? 'Edit Address' : 'Add New Address'}
        </Modal.Title>
      </Modal.Header>
      
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>First Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.first_name}
                  onChange={(e) => handleInputChange('first_name', e.target.value)}
                  disabled={loading}
                  required
                  autoFocus
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Last Name *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.last_name}
                  onChange={(e) => handleInputChange('last_name', e.target.value)}
                  disabled={loading}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Company (Optional)</Form.Label>
            <Form.Control
              type="text"
              value={formData.company}
              onChange={(e) => handleInputChange('company', e.target.value)}
              disabled={loading}
            />
          </Form.Group>

          {/* Address Section */}
          <div className="mb-3">
            <h6 className="mb-3">Address Information</h6>
            <AddressFields 
              addressData={formData}
              setAddressData={setAddressData}
              disabled={loading}
            />
          </div>

          <Row className="mb-3">
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  id="is-default-checkbox"
                  label="Set as default address"
                  checked={formData.is_default}
                  onChange={(e) => handleInputChange('is_default', e.target.checked)}
                  disabled={loading}
                />
              </Form.Group>
            </Col>
          </Row>

        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Saving...' : (address ? 'Update Address' : 'Add Address')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddressModal;


